import { Text } from "@mantine/core"
import { IconEye } from "@tabler/icons-react"
import { BaseSyntheticEvent, ReactElement } from "react"

import { ActionIcon } from "../../atoms/ActionIcons/ActionIcon"

type Props = {
  documentId: string
  showAsText?: boolean
  customText?: string
  viewUrl?: string
  documentIcon?: ReactElement
  fetchViewUrl: () => Promise<string | undefined>
}
export function DocumentView({
  showAsText,
  customText,
  fetchViewUrl,
  documentIcon,
}: Props) {
  const handleViewDocument = async (e: BaseSyntheticEvent) => {
    e.stopPropagation()
    const viewUrl = await fetchViewUrl()
    if (!viewUrl) {
      return
    }
    window.open(viewUrl, "_blank")
  }

  return showAsText ? (
    <Text fz="sm" onClick={handleViewDocument}>
      {customText ? customText : "View"}
    </Text>
  ) : (
    <ActionIcon
      icon={documentIcon ? documentIcon : <IconEye />}
      onClick={handleViewDocument}
    ></ActionIcon>
  )
}
